import React from 'react'
import {Modal as RBModal} from 'react-bootstrap'

export const Modal = (props) => {
  return <RBModal show={props.show} onHide={props.onHide}>
    { props.header && <RBModal.Header closeButton>
        <RBModal.Title>{props.header}</RBModal.Title>
      </RBModal.Header>
    }

    <RBModal.Body>
      {props.content}
      {props.children}
    </RBModal.Body>

    { props.footer && <RBModal.Footer>
        {props.footer}
      </RBModal.Footer>
    }
  </RBModal>
}
